export const convertToSlug = (Text) => {
  return (
    Text?.toLowerCase()
      .replace("&", "and")
      .replace(/ /g, "-")
      .replace(/[^\w-]+/g, "") ?? ""
  );
  };